import { configureStore } from '@reduxjs/toolkit'
import planogramPlansReducer from './slices/planogramPlansSlice'
import milestonesReducer from './slices/milestonesSlice'
import assignmentsReducer from './slices/assignmentsSlice'
import uiReducer from './slices/uiSlice'

export const store = configureStore({
  reducer: {
    planogramPlans: planogramPlansReducer,
    milestones: milestonesReducer,
    assignments: assignmentsReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch